import { Component } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../../interfaces/plugin-preview-component.interface';
import { TrainingSchedulesData } from '../../../../../../models/wizard-plugin-models/training-schedules-data';

@Component({
  selector: 'app-training-schedules-preview',
  templateUrl: './training-schedules-preview.component.html',
  styleUrl: './training-schedules-preview.component.css'
})
export class TrainingSchedulesPreviewComponent implements IPluginPreviewComponent {

  public previewData: TrainingSchedulesData | undefined;

  setData(data: any): void {
    if (data) {
      this.previewData = data as TrainingSchedulesData;
    }
  }

  // Helper to format participants as a comma-separated string
  getParticipants(): string {
    return this.previewData?.TrainingSchedulesData[0].participants?.join(', ') || '';
  }

  // Helper to format trainers as a comma-separated string
  getTrainers(): string {
    return this.previewData?.TrainingSchedulesData[0]?.trainers?.map(t => t.name).join(', ') || '';
  }

  // Helper to format date range
  formatDateRange(dr: any): string {
    if (!dr) return '';
    const start = dr.startDate ? new Date(dr.startDate) : null;
    const end = dr.endDate ? new Date(dr.endDate) : null;
    const startStr = start ? start.toLocaleDateString() : '';
    const endStr = end ? end.toLocaleDateString() : '';
    return `${startStr} ${dr.startTime || ''} - ${endStr} ${dr.endTime || ''}`;
  }

  // Helper to safely stringify resource controls
  formatResourceControls(ctrl: any): string {
    if (!ctrl) return '';
    try {
      return JSON.stringify(ctrl);
    } catch {
      return '';
    }
  }
}
